import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { tenantService } from '../../../services/TenantService';
import { tenantQueryKeys } from '../tenantQueryKeys';

type UseTenantProfileQueryOptions = {
  enabled?: boolean;
};

export function useTenantProfileQuery(options?: UseTenantProfileQueryOptions) {
  const { user } = useAuth();

  return useQuery({
    queryKey: tenantQueryKeys.profile(),
    enabled: (options?.enabled ?? true) && Boolean(user),
    queryFn: () => tenantService.getProfile(),
  });
}
